/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from 'vue';
import Axios from 'axios';
import { ERROR } from '@route-types';

Axios.defaults.baseURL = process.env.API_LOCATION;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401 || error.response?.data?.code === 'EXPIRED_SESSION') {
      Vue.router.push({ name: ERROR, params: { error: { status: 401 }, originalParams: Vue.router.currentRoute?.params } });

      error.response.handled = true;
    }

    return Promise.reject(error);
  }
);

// Bind Axios to Vue.
Vue.$http = Axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});
